import { authGet } from "@api/auth/auth";

export const getDeploymentContributors = (
  deployment_id: string
): Promise<number> => {
  const url = `/api/agent/deployments/${deployment_id}/contributors`;
  return authGet<{ count: number }>(url).then((result) => result.count);
};
